import router from "@/router";
import Gobalstore from "../index";
export const actions = {
  /* get all user */
  getAllUser: function (localStore) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/user/all-users`,
    })
      .then(function (response) {
        localStore.commit("setAllUser", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  removeBussiness: function (localStore, user) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "PATCH",
      url: `/admin/guarded/management/user/delete-user/${user.user_id}`,
    })
      .then(function (response) {
        localStore.commit("deleteUser", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(() => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
};
